import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'qpx-quippy-typing-indicator',
    templateUrl: './typing-indicator.html',
    styleUrls: ['./typing-indicator.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'quippy-loading',
        role: 'status',
        'aria-label': 'Quippy is thinking',
    },
})
export class QuippyTypingIndicator {}
